export class VisitHistoryDataModel {
	DOCTORNAME: string;

	VISITDATE: string;

	PAYMENTTYPE: string;

	VISITTYPE: string;

	PURPOSEOFVISIT: string;	
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/VisitHistory/VisitHistoryDataModel.ts